import {
    Avatar,
    Box,
    IconButton,
    Typography
    } from "@mui/material";
import { useUserContext } from "../../contexts/UserContext";

interface AppBarUserMenuProps {
  onProfileClick: (event: React.MouseEvent<HTMLElement>) => void;
}

/**
 * Menu użytkownika z avatarem w AppBar
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko menu użytkownika
 */
export default function AppBarUserMenu({ onProfileClick }: AppBarUserMenuProps) {
  const { user } = useUserContext();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body2"
        sx={{
          color: "#6c6c6c",
          mr: 1,
          display: { xs: "none", sm: "block" },
        }}
      >
        {user?.firstName} {user?.lastName}
      </Typography>

      <IconButton
        onClick={onProfileClick}
        size="small"
        sx={{
          p: 0.5,
          border: `2px solid #eee`,
          "&:hover": {
            borderColor: "#6366f1",
            backgroundColor: "#f1e7de",
          },
        }}
      >
        <Avatar
          sx={{
            width: 32,
            height: 32,
            bgcolor: "#6366f1",
            fontSize: "0.875rem",
          }}
        >
          {user?.firstName?.[0]}
          {user?.lastName?.[0]}
        </Avatar>
      </IconButton>
    </Box>
  );
}
